<template lang="pug">
  v-pagination(v-model="currentPage" :length="count" :total-visible="7" color="#FFDC26")
</template>
<script>
export default {
  props: {
    page: {
      type: Number,
      default: 1
    },
    count: {
      type: Number,
      default: 0
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(value) {
        this.$emit('change-page', value)
      }
    }
  }
}
</script>
<style lang="scss">
.v-pagination {
  &__item--active {
    color: #333 !important;
  }
}
</style>
